import lottie from "lottie-web";
import isInViewport from "../../../../assets/scripts/extends/components/is-in-viewport";

const firstSvgAnimation = document.querySelector("#tab-content-1 .svg");
if (firstSvgAnimation) {
  const url = firstSvgAnimation.dataset.url;
  lottie.loadAnimation({
    container: firstSvgAnimation,
    renderer: "svg",
    name: "svg-1",
    loop: false,
    autoplay: false,
    path: url,
  });

  const runLottie = () => {
    if (isInViewport(firstSvgAnimation)) {
      setTimeout(function () {
        lottie.play();
      }, 750);
    }
  };

  ["load", "resize", "scroll"].forEach(function (evt) {
    window.addEventListener(evt, runLottie);
  });
}

function openTab(evt) {
  let i, tabcontent, tablinks, tabindex;

  tabcontent = document.getElementsByClassName("tabs-content-item");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("open");
  }

  tablinks = document.getElementsByClassName("tabs-nav-item");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  tabindex = evt.dataset.tab;
  const currentTab = document.getElementById("tab-content-" + tabindex);
  const svgAnimation = currentTab.querySelector(".svg");
  currentTab.classList.add("open");
  evt.className += " active";

  if (svgAnimation) {
    const url = svgAnimation.dataset.url;
    lottie.destroy("svg-" + tabindex);
    lottie.loadAnimation({
      container: svgAnimation,
      renderer: "svg",
      loop: false,
      autoplay: false,
      name: "svg-" + tabindex,
      path: url,
    });

    if (isInViewport(svgAnimation)) {
      setTimeout(function () {
        lottie.play();
      }, 750);
    }
  }
}

document.body.addEventListener("click", function (e) {
  if (e.target && (e.target.matches(".tabs-nav-item") || e.target.matches(".tabs-nav-no") || e.target.matches(".tabs-nav-label"))) {
    let tab;
    if (e.target.matches(".tabs-nav-item")) {
      tab = e.target;
    } else {
      tab = e.target.parentElement;
    }
    openTab(tab);
  }
});
